import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Car, Menu, X } from "lucide-react";
import { useState } from "react";

export default function PublicHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/used-car-loans", label: "Used Car Loans" },
    { to: "/check-eligibility", label: "Check Eligibility" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/cardr-advantage", label: "CarDr Advantage" },
    { to: "/dealer-partners", label: "Dealer Partners" },
    { to: "/dsa-partners", label: "DSA Partners" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200" data-testid="public-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 lg:px-8 h-16">
        <Link to="/" className="flex items-center" data-testid="brand-home-link">
          <img src="/assets/carfin-logo.png" alt="CarFin India · Red Fort Capital Finance NBFC" className="h-8" />
        </Link>
        <nav className="hidden lg:flex items-center gap-6">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${isActive ? "text-teal-700" : "text-slate-600 hover:text-slate-900"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="outline" data-testid="header-dashboard-btn" onClick={() => navigate("/login")}>Open Dashboard</Button>
              <Button variant="ghost" data-testid="header-logout-btn" onClick={logout}>Sign out</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" data-testid="header-login-btn" onClick={() => navigate("/login")}>Sign in</Button>
              <Button data-testid="header-apply-btn" className="bg-teal-600 hover:bg-teal-700 text-white" onClick={() => navigate("/apply")}>Apply for Loan</Button>
            </>
          )}
        </div>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-2" data-testid="mobile-menu">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-sm text-slate-700">{l.label}</NavLink>
          ))}
          <div className="flex gap-2 pt-2">
            <Button variant="outline" className="flex-1" onClick={() => { setOpen(false); navigate("/login"); }}>Sign in</Button>
            <Button className="flex-1 bg-teal-600 hover:bg-teal-700" onClick={() => { setOpen(false); navigate("/apply"); }}>Apply</Button>
          </div>
        </div>
      )}
    </header>
  );
}
